import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ITechStackMatrix } from '../../models';
import { VersionService } from './version.service';
import { STATUS_CLASSES } from './eol.interfaces';
import config from '../../../config';

@Injectable({
  providedIn: 'root',
})
export class DateEolService {
  apiUrl = config.API_GATEWAY_ENDPOINT;
  readonly STATUS_CLASSES = STATUS_CLASSES;

  constructor(
    readonly http: HttpClient,
    private versionService: VersionService,
  ) {}

  async fetchEOLStack(): Promise<ITechStackMatrix[]> {
    return lastValueFrom(
      this.http.get<ITechStackMatrix[]>(`${this.apiUrl}/eol`),
    );
  }

  _getRecommendedVersion(
    techName: string,
    eolStack: any[],
    currentVersion?: string,
  ): string {
    return this.versionService.getRecommendedVersion(
      techName,
      eolStack,
      currentVersion,
    );
  }
}
